/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Number of days to forecast.
 */
export type Horizon = number | string;

export type ForecastTrajectorySpec = {
  /**
   * Specific model to use for forecast window.
   */
  model: string;
  /**
   * Number of days to forecast.
   */
  horizon: number | string;
};

/** @internal */
export const Horizon$inboundSchema: z.ZodType<Horizon, z.ZodTypeDef, unknown> =
  z.union([z.number().int(), z.string()]);

/** @internal */
export type Horizon$Outbound = number | string;

/** @internal */
export const Horizon$outboundSchema: z.ZodType<
  Horizon$Outbound,
  z.ZodTypeDef,
  Horizon
> = z.union([z.number().int(), z.string()]);

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace Horizon$ {
  /** @deprecated use `Horizon$inboundSchema` instead. */
  export const inboundSchema = Horizon$inboundSchema;
  /** @deprecated use `Horizon$outboundSchema` instead. */
  export const outboundSchema = Horizon$outboundSchema;
  /** @deprecated use `Horizon$Outbound` instead. */
  export type Outbound = Horizon$Outbound;
}

export function horizonToJSON(horizon: Horizon): string {
  return JSON.stringify(Horizon$outboundSchema.parse(horizon));
}

export function horizonFromJSON(
  jsonString: string,
): SafeParseResult<Horizon, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Horizon$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Horizon' from JSON`,
  );
}

/** @internal */
export const ForecastTrajectorySpec$inboundSchema: z.ZodType<
  ForecastTrajectorySpec,
  z.ZodTypeDef,
  unknown
> = z.object({
  model: z.string(),
  horizon: z.union([z.number().int(), z.string()]),
});

/** @internal */
export type ForecastTrajectorySpec$Outbound = {
  model: string;
  horizon: number | string;
};

/** @internal */
export const ForecastTrajectorySpec$outboundSchema: z.ZodType<
  ForecastTrajectorySpec$Outbound,
  z.ZodTypeDef,
  ForecastTrajectorySpec
> = z.object({
  model: z.string(),
  horizon: z.union([z.number().int(), z.string()]),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ForecastTrajectorySpec$ {
  /** @deprecated use `ForecastTrajectorySpec$inboundSchema` instead. */
  export const inboundSchema = ForecastTrajectorySpec$inboundSchema;
  /** @deprecated use `ForecastTrajectorySpec$outboundSchema` instead. */
  export const outboundSchema = ForecastTrajectorySpec$outboundSchema;
  /** @deprecated use `ForecastTrajectorySpec$Outbound` instead. */
  export type Outbound = ForecastTrajectorySpec$Outbound;
}

export function forecastTrajectorySpecToJSON(
  forecastTrajectorySpec: ForecastTrajectorySpec,
): string {
  return JSON.stringify(
    ForecastTrajectorySpec$outboundSchema.parse(forecastTrajectorySpec),
  );
}

export function forecastTrajectorySpecFromJSON(
  jsonString: string,
): SafeParseResult<ForecastTrajectorySpec, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ForecastTrajectorySpec$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ForecastTrajectorySpec' from JSON`,
  );
}
